import { render } from "./GenogramLegendSymbolIcon.vue?vue&type=template&id=bd0f0f9e"
import script from "./GenogramLegendSymbolIcon.vue?vue&type=script&lang=js"
export * from "./GenogramLegendSymbolIcon.vue?vue&type=script&lang=js"

import "./GenogramLegendSymbolIcon.vue?vue&type=style&index=0&id=bd0f0f9e&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__